import { lazy } from 'react';

export const BillingPage = lazy(() =>
  import('@/capabilities/billing/pages/tenant-administration/BillingPage').then((m) => ({
    default: m.BillingPage,
  }))
);

// Billing (Contract Templates)
export const ContractTemplates = lazy(() =>
  import('@/capabilities/billing/pages/ContractTemplates').then((m) => ({
    default: m.ContractTemplates,
  }))
);
